import { render, staticRenderFns } from "./SpacePartnerLogin.vue?vue&type=template&id=06a5c582&scoped=true"
import script from "./SpacePartnerLogin.vue?vue&type=script&lang=js"
export * from "./SpacePartnerLogin.vue?vue&type=script&lang=js"
import style0 from "./SpacePartnerLogin.vue?vue&type=style&index=0&id=06a5c582&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a5c582",
  null
  
)

export default component.exports